import { FEATURE_TOGGLES } from 'constants/featureToggles';
import { isFeatureEnabled } from 'utilities/util';
import store from './../../../store';

export class CostColumnsData {
    public static TYPES = {
        COST: 'COST',
        REVENUE: 'REV'
    }
    public static ERROR_MSG = {
        REV: 'Receiving FCR scenario: Revenue items cannot be added from CBL. Please use Export job details page.',
        GENERIC: 'Updates only available through Export Job view'
    }
    public static DEFAULT_CURRENCY_LIST = [
        'AED',
        'ARS',
        'AUD',
        'BDT',
        'BRL',
        'CAD',
        'CHF',
        'CLP',
        'CNY',
        'COP',
        'CZK',
        'DKK',
        'DZD',
        'EGP',
        'EUR',
        'GBP',
        'HKD',
        'HUF',
        'IDR',
        'ILS',
        'INR',
        'JOD',
        'JPY',
        'KRW',
        'LKR',
        'MAD',
        'MMK',
        'MUR',
        'MXN',
        'MYR',
        'NOK',
        'NZD',
        'PEN',
        'PHP',
        'PKR',
        'PLN',
        'SAR',
        'SEK',
        'SGD',
        'THB',
        'TRY',
        'TWD',
        'USD',
        'VND',
        'ZAR'
    ];
    public static LOCAL_CURRENCY_LIST = [
        { country: 'AE', currency: 'AED' },
        { country: 'AO', currency: 'AOA' },
        { country: 'AR', currency: 'ARS' },
        { country: 'AT', currency: 'EUR' },
        { country: 'AU', currency: 'AUD' },
        { country: 'BA', currency: 'USD' },
        { country: 'BD', currency: 'BDT' },
        { country: 'BE', currency: 'EUR' },
        { country: 'BF', currency: 'XOF' },
        { country: 'BG', currency: 'BGN' },
        { country: 'BH', currency: 'BHD' },
        { country: 'BI', currency: 'BIF' },
        { country: 'BJ', currency: 'XOF' },
        { country: 'BM', currency: 'BMD' },
        { country: 'BR', currency: 'BRL' },
        { country: 'BW', currency: 'BWP' },
        { country: 'BY', currency: 'BYR' },
        { country: 'CA', currency: 'CAD' },
        { country: 'CD', currency: 'CDF' },
        { country: 'CG', currency: 'EUR' },
        { country: 'CH', currency: 'CHF' },
        { country: 'CI', currency: 'XAF' },
        { country: 'CL', currency: 'CLP' },
        { country: 'CM', currency: 'XAF' },
        { country: 'CN', currency: 'CNY' },
        { country: 'CO', currency: 'COP' },
        { country: 'CR', currency: 'CRC' },
        { country: 'CY', currency: 'EUR' },
        { country: 'CZ', currency: 'CZK' },
        { country: 'DE', currency: 'EUR' },
        { country: 'DJ', currency: 'DJF' },
        { country: 'DK', currency: 'DKK' },
        { country: 'DO', currency: 'DOP' },
        { country: 'DZ', currency: 'DZD' },
        { country: 'EC', currency: 'USD' },
        { country: 'EE', currency: 'EUR' },
        { country: 'EG', currency: 'EGP' },
        { country: 'ES', currency: 'EUR' },
        { country: 'ET', currency: 'ETB' },
        { country: 'FI', currency: 'EUR' },
        { country: 'FO', currency: 'DKK' },
        { country: 'FR', currency: 'EUR' },
        { country: 'GA', currency: 'XAF' },
        { country: 'GB', currency: 'GBP' },
        { country: 'GE', currency: 'GEL' },
        { country: 'GH', currency: 'GHS' },
        { country: 'GM', currency: 'GMD' },
        { country: 'GN', currency: 'GNF' },
        { country: 'GR', currency: 'EUR' },
        { country: 'GT', currency: 'GTQ' },
        { country: 'GW', currency: 'XOF' },
        { country: 'HK', currency: 'HKD' },
        { country: 'HN', currency: 'HNL' },
        { country: 'HR', currency: 'HRK' },
        { country: 'HU', currency: 'HUF' },
        { country: 'ID', currency: 'IDR' },
        { country: 'IE', currency: 'EUR' },
        { country: 'IL', currency: 'ILS' },
        { country: 'IN', currency: 'INR' },
        { country: 'IQ', currency: 'USD' },
        { country: 'IR', currency: 'IRR' },
        { country: 'IT', currency: 'EUR' },
        { country: 'JO', currency: 'JOD' },
        { country: 'JP', currency: 'JPY' },
        { country: 'KE', currency: 'KES' },
        { country: 'KH', currency: 'KHR' },
        { country: 'KR', currency: 'KRW' },
        { country: 'KW', currency: 'KWD' },
        { country: 'KZ', currency: 'KZT' },
        { country: 'LB', currency: 'LBP' },
        { country: 'LK', currency: 'LKR' },
        { country: 'LR', currency: 'LRD' },
        { country: 'LS', currency: 'LSL' },
        { country: 'LT', currency: 'LTL' },
        { country: 'LU', currency: 'EUR' },
        { country: 'LV', currency: 'LVL' },
        { country: 'MA', currency: 'MAD' },
        { country: 'MG', currency: 'MGA' },
        { country: 'ML', currency: 'XOF' },
        { country: 'MM', currency: 'MMK' },
        { country: 'MO', currency: 'HKD' },
        { country: 'MR', currency: 'MRU' },
        { country: 'MU', currency: 'MUR' },
        { country: 'MW', currency: 'MWK' },
        { country: 'MX', currency: 'MXN' },
        { country: 'MY', currency: 'MYR' },
        { country: 'MZ', currency: 'MZN' },
        { country: 'NA', currency: 'NAD' },
        { country: 'NE', currency: 'XOF' },
        { country: 'NG', currency: 'NGN' },
        { country: 'NI', currency: 'NIO' },
        { country: 'NL', currency: 'EUR' },
        { country: 'NO', currency: 'NOK' },
        { country: 'NZ', currency: 'NZD' },
        { country: 'OM', currency: 'OMR' },
        { country: 'PA', currency: 'USD' },
        { country: 'PE', currency: 'PEN' },
        { country: 'PH', currency: 'PHP' },
        { country: 'PK', currency: 'PKR' },
        { country: 'PL', currency: 'PLN' },
        { country: 'PT', currency: 'EUR' },
        { country: 'QA', currency: 'QAR' },
        { country: 'RO', currency: 'RON' },
        { country: 'RU', currency: 'RUB' },
        { country: 'RW', currency: 'RWF' },
        { country: 'SA', currency: 'SAR' },
        { country: 'SD', currency: 'SDG' },
        { country: 'SE', currency: 'SEK' },
        { country: 'SG', currency: 'SGD' },
        { country: 'SI', currency: 'EUR' },
        { country: 'SK', currency: 'SKK' },
        { country: 'SL', currency: 'SLL' },
        { country: 'SN', currency: 'XOF' },
        { country: 'SS', currency: 'SSP' },
        { country: 'SV', currency: 'SVC' },
        { country: 'SZ', currency: 'SZL' },
        { country: 'TG', currency: 'XOF' },
        { country: 'TH', currency: 'THB' },
        { country: 'TN', currency: 'TND' },
        { country: 'TR', currency: 'TRL' },
        { country: 'TT', currency: 'TTD' },
        { country: 'TW', currency: 'TWD' },
        { country: 'TZ', currency: 'TZS' },
        { country: 'UA', currency: 'UAH' },
        { country: 'UG', currency: 'UGX' },
        { country: 'US', currency: 'USD' },
        { country: 'UY', currency: 'UYU' },
        { country: 'VE', currency: 'VEF' },
        { country: 'VG', currency: 'USD' },
        { country: 'VN', currency: 'VND' },
        { country: 'ZA', currency: 'ZAR' },
        { country: 'ZM', currency: 'ZMK' },
        { country: 'ZW', currency: 'USD' }
    ];
    public static GetLocalCurrency = (selectedCurrrency: string = 'CN'): string => {
        let selected = 'CNY';
        if (selectedCurrrency) {
            const resp = CostColumnsData.LOCAL_CURRENCY_LIST.filter((entry: any) => entry.country === selectedCurrrency);
            selected = resp && resp.length >= 1 ? resp[0].currency : selected;
        }
        return selected
    };
    public static requiredCostData = (isPassThroughEnabled: boolean = false, isSourceAthena: boolean = false) => {
        const state = store.getState();
        const isNegativeRateAllowed = isFeatureEnabled(FEATURE_TOGGLES.FINOPS_ALLOW_NEGATIVE_RATE, state.featureToggle.featureToggles);
        const baseData = [
            { key: 'chargeItem', label: 'Charge Item' },
            { key: 'quantity', label: 'QTY', type: 'number' },
            { key: 'uom', label: 'UOM' },
            { key: 'payToParty', label: 'Pay to Party' },
            { key: 'localCurrency', label: 'Currency' },
            { key: 'condCurrency', label: 'Currency' },
        ];
        if (isNegativeRateAllowed) {
            baseData.push({ key: 'rate', label: 'Unit Price' });
        } else {
            baseData.push({ key: 'rate', label: 'Unit Price', type: 'number' });
        }
        if (isPassThroughEnabled) {
            baseData.push({ key: 'passThrough', label: 'Pass Through' });
        }
        if (isSourceAthena) {
            baseData.push({ key: 'serviceRenderedAt', label: 'Service Rendered At' });
        }
        return baseData;
    }
    public static requiredRevenueData = (isPassThroughEnabled: boolean = false, isSourceAthena: boolean = false) => {
        const state = store.getState();
        const isNegativeRateAllowed = isFeatureEnabled(FEATURE_TOGGLES.FINOPS_ALLOW_NEGATIVE_RATE, state.featureToggle.featureToggles);
        const baseData = [
            { key: 'chargeItem', label: 'Charge Item' },
            { key: 'quantity', label: 'QTY', type: 'number' },
            { key: 'uom', label: 'UOM' },
            { key: 'billToParty', label: 'Bill to Party' },
            { key: 'localCurrency', label: 'Currency' },
            { key: 'condCurrency', label: 'Currency' },
        ];
        if (isNegativeRateAllowed) {
            baseData.push({ key: 'rate', label: 'Unit Price' });
        } else {
            baseData.push({ key: 'rate', label: 'Unit Price', type: 'number' });
        }
        if (isPassThroughEnabled) {
            baseData.push({ key: 'passThrough', label: 'Pass Through' });
        }
        if (isSourceAthena) {
            baseData.push({ key: 'serviceRenderedAt', label: 'Service Rendered At' });
        }
        return baseData;
    }
    public static getETSSubCols = () => ([
        {
            headerClassName: 'data-table header',
            accessor: 'equipmentNumber',
            isHyperlink: false,
            fieldHeader: 'Equipment Number',
            show: true
        }, {
            headerClassName: 'data-table header',
            accessor: 'container',
            isHyperlink: false,
            fieldHeader: 'Container Size/Type',
            show: true
        }, {
            headerClassName: 'data-table header',
            accessor: 'substitution',
            isHyperlink: false,
            fieldHeader: 'Substitution Size/Type',
            show: true
        }, {
            headerClassName: 'data-table header',
            accessor: 'cblNumber',
            isHyperlink: false,
            fieldHeader: 'CBL Number',
            show: true,
        }, {
            headerClassName: 'data-table header',
            className: '-number',
            accessor: 'quantity',
            isHyperlink: false,
            fieldHeader: 'QTY',
            show: true
        }, {
            headerClassName: 'data-table header',
            accessor: 'equipmentTransportShipmentId',
            isHyperlink: false,
            fieldHeader: 'ETS ID',
            show: true
        }, {
            headerClassName: 'data-table header',
            accessor: 'rateDetailSplitId',
            isHyperlink: false,
            fieldHeader: 'Rate Details Split ID',
            show: true
        }
    ])
    public static getETSDialogSubCols = () => ([
        {
            headerClassName: 'data-table header',
            accessor: 'EquipmentNumber',
            isHyperlink: false,
            fieldHeader: 'Equipment Number',
            show: true
        }, {
            headerClassName: 'data-table header',
            accessor: 'container',
            isHyperlink: false,
            fieldHeader: 'Container Size/Type',
            show: true
        }, {
            headerClassName: 'data-table header',
            accessor: 'substitution',
            isHyperlink: false,
            fieldHeader: 'Substitution Size/Type',
            show: true
        }, {
            headerClassName: 'data-table header',
            accessor: 'cBLNumber',
            isHyperlink: false,
            fieldHeader: 'CBL Number',
            show: true,
        }, {
            headerClassName: 'data-table header',
            className: '-number',
            accessor: 'QuantityPercentage',
            isHyperlink: false,
            fieldHeader: 'QTY',
            show: true
        }, {
            headerClassName: 'data-table header',
            accessor: 'etsId',
            isHyperlink: false,
            fieldHeader: 'ETS ID',
            show: true
        }, {
            headerClassName: 'data-table header',
            accessor: 'essoRateDetailsSplitId',
            isHyperlink: false,
            fieldHeader: 'Rate Details Split ID',
            show: true
        }
    ])
    public static getCostFCRSubCols = () => ([
        {
            headerClassName: 'data-table header',
            accessor: 'equipmentNumber',
            isHyperlink: false,
            fieldHeader: 'Equipment Number',
            show: true,
        }, {
            headerClassName: 'data-table header',
            accessor: 'container',
            isHyperlink: false,
            fieldHeader: 'Container Size/Type',
            show: true
        }, {
            headerClassName: 'data-table header',
            accessor: 'substitution',
            isHyperlink: false,
            fieldHeader: 'Substitution Size/Type',
            show: true
        }, {
            headerClassName: 'data-table header',
            accessor: 'cblNumber',
            isHyperlink: false,
            fieldHeader: 'CBL Number',
            show: true,
        }, {
            headerClassName: 'data-table header',
            accessor: 'bookingNumber',
            isHyperlink: false,
            fieldHeader: 'Booking Number',
            show: true,
        }, {
            headerClassName: 'data-table header',
            className: '-number',
            accessor: 'quantity',
            isHyperlink: false,
            fieldHeader: 'QTY',
            show: true
        }, {
            headerClassName: 'data-table header',
            accessor: 'bookingSplitId',
            isHyperlink: false,
            fieldHeader: 'Booking Split ID',
            show: true
        }, {
            headerClassName: 'data-table header',
            accessor: 'essoRateDetailsSplitId',
            isHyperlink: false,
            fieldHeader: 'Rate Details Split ID',
            show: true
        }
    ])

    public static getCostEqSubCols = (isExtraDocumentFeatureEnabled: boolean) => ([
        {
            headerClassName: 'data-table header',
            accessor: 'equipmentNumber',
            isHyperlink: false,
            fieldHeader: 'Equipment Number',
            show: true
        }, {
            headerClassName: 'data-table header',
            accessor: 'container',
            isHyperlink: false,
            fieldHeader: 'Container Size/Type',
            show: true
        }, {
            headerClassName: 'data-table header',
            accessor: 'substitution',
            isHyperlink: false,
            fieldHeader: 'Substitution Size/Type',
            show: true
        }, {
            headerClassName: 'data-table header',
            accessor: 'documentNumber',
            isHyperlink: false,
            fieldHeader: isExtraDocumentFeatureEnabled ? 'Document Number' : 'FCR Number',
            show: true,
        }, {
            headerClassName: 'data-table header',
            accessor: 'cblNumber',
            isHyperlink: false,
            fieldHeader: 'CBL Number',
            show: true,
        }, {
            headerClassName: 'data-table header',
            accessor: 'bookingNumber',
            isHyperlink: false,
            fieldHeader: 'Booking Number',
            show: true,
        }, {
            headerClassName: 'data-table header',
            className: '-number',
            accessor: 'quantity',
            isHyperlink: false,
            fieldHeader: 'QTY',
            show: true
        }, {
            headerClassName: 'data-table header',
            accessor: 'bookingSplitId',
            isHyperlink: false,
            fieldHeader: 'Booking Split ID',
            show: true
        }, {
            headerClassName: 'data-table header',
            accessor: 'essoRateDetailsSplitId',
            isHyperlink: false,
            fieldHeader: 'Rate Details Split ID',
            show: true
        }
    ])
    public static getCostCBLSubCols = (isExtraDocumentFeatureEnabled: boolean) => ([
        {
            headerClassName: 'data-table header',
            accessor: 'equipmentNumber',
            isHyperlink: false,
            fieldHeader: 'Equipment Number',
            show: true,
        }, {
            headerClassName: 'data-table header',
            accessor: 'container',
            isHyperlink: false,
            fieldHeader: 'Container Size/Type',
            show: true
        }, {
            headerClassName: 'data-table header',
            accessor: 'substitution',
            isHyperlink: false,
            fieldHeader: 'Substitution Size/Type',
            show: true
        }, {
            headerClassName: 'data-table header',
            accessor: 'documentNumber',
            isHyperlink: false,
            fieldHeader: isExtraDocumentFeatureEnabled ? 'Document Number' : 'FCR Number',
            show: true,
        }, {
            headerClassName: 'data-table header',
            accessor: 'bookingNumber',
            isHyperlink: false,
            fieldHeader: 'Booking Number',
            show: true,
        }, {
            headerClassName: 'data-table header',
            className: '-number',
            accessor: 'quantity',
            isHyperlink: false,
            fieldHeader: 'QTY',
            show: true
        }, {
            headerClassName: 'data-table header',
            accessor: 'bookingSplitId',
            isHyperlink: false,
            fieldHeader: 'Booking Split ID',
            show: true
        }, {
            headerClassName: 'data-table header',
            accessor: 'essoRateDetailsSplitId',
            isHyperlink: false,
            fieldHeader: 'Rate Details Split ID',
            show: true
        }
    ])
    public static getCostSubCols = (isExtraDocumentFeatureEnabled: boolean) => ([
        {
            headerClassName: 'data-table header',
            accessor: 'documentNumber',
            isHyperlink: false,
            fieldHeader: isExtraDocumentFeatureEnabled ? 'Document Number' : 'FCR Number',
            show: true,
        }, {
            headerClassName: 'data-table header',
            accessor: 'cblNumber',
            isHyperlink: false,
            fieldHeader: 'CBL Number',
            show: true
        }, {
            headerClassName: 'data-table header',
            accessor: 'equipmentNumber',
            isHyperlink: false,
            fieldHeader: 'Equipment Number',
            show: true
        }, {
            headerClassName: 'data-table header',
            accessor: 'container',
            isHyperlink: false,
            fieldHeader: 'Container Size/Type',
            show: true
        }, {
            headerClassName: 'data-table header',
            accessor: 'substitution',
            isHyperlink: false,
            fieldHeader: 'Substitution Size/Type',
            show: true
        }, {
            headerClassName: 'data-table header',
            className: '-number',
            accessor: 'quantity',
            isHyperlink: false,
            fieldHeader: 'QTY',
            show: true,
        }, {
            headerClassName: 'data-table header',
            accessor: 'bookingSplitId',
            isHyperlink: false,
            fieldHeader: 'Booking Split ID',
            show: true
        }, {
            headerClassName: 'data-table header',
            accessor: 'essoRateDetailsSplitId',
            isHyperlink: false,
            fieldHeader: 'Rate Details Split ID',
            show: true
        }
    ])
    public static getDialogFcrCostRevSubCols = () => ([
        {
            headerClassName: 'data-table header',
            accessor: 'EquipmentNumber',
            isHyperlink: false,
            fieldHeader: 'Equipment Number',
            show: true
        }, {
            headerClassName: 'data-table header',
            accessor: 'container',
            isHyperlink: false,
            fieldHeader: 'Container Size/Type',
            show: true
        }, {
            headerClassName: 'data-table header',
            accessor: 'substitution',
            isHyperlink: false,
            fieldHeader: 'Substitution Size/Type',
            show: true
        }, {
            headerClassName: 'data-table header',
            accessor: 'cBLNumber',
            isHyperlink: false,
            fieldHeader: 'CBL Number',
            show: true
        }, {
            headerClassName: 'data-table header',
            accessor: 'BookingNumber',
            isHyperlink: false,
            fieldHeader: 'Booking Number',
            show: true
        }, {
            headerClassName: 'data-table header',
            accessor: 'QuantityPercentage',
            editable: true,
            editType: 'text',
            fieldHeader: '%',
            show: true,
        }, {
            headerClassName: 'data-table header',
            accessor: 'BookingSplitId',
            isHyperlink: false,
            fieldHeader: 'Booking Split ID',
            show: true
        }, {
            headerClassName: 'data-table header',
            accessor: 'essoRateDetailsSplitId',
            isHyperlink: false,
            fieldHeader: 'Rate Details Split ID',
            show: true
        }
    ])
    public static getDialogBookingCostRevSubCols = (isExtraDocumentFeatureEnabled: boolean) => ([
        {
            headerClassName: 'data-table header',
            accessor: 'DocumentNumber',
            isHyperlink: false,
            fieldHeader: isExtraDocumentFeatureEnabled ? 'Document Number' : 'FCR Number',
            show: true,
        }, {
            headerClassName: 'data-table header',
            accessor: 'cBLNumber',
            isHyperlink: false,
            fieldHeader: 'CBL Number',
            show: true
        }, {
            headerClassName: 'data-table header',
            accessor: 'EquipmentNumber',
            isHyperlink: false,
            fieldHeader: 'Equipment Number',
            show: true
        }, {
            headerClassName: 'data-table header',
            accessor: 'container',
            isHyperlink: false,
            fieldHeader: 'Container Size/Type',
            show: true
        }, {
            headerClassName: 'data-table header',
            accessor: 'substitution',
            isHyperlink: false,
            fieldHeader: 'Substitution Size/Type',
            show: true
        },
        {
            headerClassName: 'data-table header',
            accessor: 'QuantityPercentage',
            editable: true,
            editType: 'text',
            fieldHeader: '%',
            show: true,
        }, {
            headerClassName: 'data-table header',
            accessor: 'BookingSplitId',
            isHyperlink: false,
            fieldHeader: 'Booking Split ID',
            show: true
        }, {
            headerClassName: 'data-table header',
            accessor: 'essoRateDetailsSplitId',
            isHyperlink: false,
            fieldHeader: 'Rate Details Split ID',
            show: true
        }
    ])
    public static getDialogCblCostRevSubCols = (isExtraDocumentFeatureEnabled: boolean) => ([
        {
            headerClassName: 'data-table header',
            accessor: 'EquipmentNumber',
            isHyperlink: false,
            fieldHeader: 'Equipment Number',
            show: true
        }, {
            headerClassName: 'data-table header',
            accessor: 'container',
            isHyperlink: false,
            fieldHeader: 'Container Size/Type',
            show: true
        }, {
            headerClassName: 'data-table header',
            accessor: 'substitution',
            isHyperlink: false,
            fieldHeader: 'Substitution Size/Type',
            show: true
        }, {
            headerClassName: 'data-table header',
            accessor: 'DocumentNumber',
            isHyperlink: false,
            fieldHeader: isExtraDocumentFeatureEnabled ? 'Document Number' : 'FCR Number',
            show: true
        }, {
            headerClassName: 'data-table header',
            accessor: 'BookingNumber',
            isHyperlink: false,
            fieldHeader: 'Booking Number',
            show: true,
        }, {
            headerClassName: 'data-table header',
            accessor: 'QuantityPercentage',
            editable: true,
            editType: 'text',
            fieldHeader: '%',
            show: true,
        }, {
            headerClassName: 'data-table header',
            accessor: 'BookingSplitId',
            isHyperlink: false,
            fieldHeader: 'Booking Split ID',
            show: true
        }, {
            headerClassName: 'data-table header',
            accessor: 'essoRateDetailsSplitId',
            isHyperlink: false,
            fieldHeader: 'Rate Details Split ID',
            show: true
        }
    ])

    public static getDialogCblDataDistributionSubCols = (isExtraDocumentFeatureEnabled: boolean) => ([
        {
            headerClassName: 'data-table header',
            accessor: 'equipmentNumber',
            isHyperlink: false,
            fieldHeader: 'Equipment Number',
            show: true
        }, {
            headerClassName: 'data-table header',
            accessor: 'containerSizeType',
            isHyperlink: false,
            fieldHeader: 'Size/Type',
            show: true
        }, {
            headerClassName: 'data-table header',
            accessor: 'substitutionSizeType',
            isHyperlink: false,
            fieldHeader: 'SubSize/Type',
            show: true
        }, {
            headerClassName: 'data-table header',
            accessor: 'primaryDocumentNumber',
            isHyperlink: false,
            fieldHeader: isExtraDocumentFeatureEnabled ? 'Primary Doc Number' : 'FCR Number',
            show: true
        }, {
            headerClassName: 'data-table header',
            accessor: 'bookingNumber',
            isHyperlink: false,
            fieldHeader: 'Booking Number',
            show: true,
        }, {
            headerClassName: 'data-table header',
            accessor: 'quantity',
            editable: true,
            editType: 'text',
            fieldHeader: 'Quantity',
            show: true,
        }
    ])

    public static getCostorRevenueColumn = (
        currencyList: string[] = CostColumnsData.DEFAULT_CURRENCY_LIST,
        chargeCodes: string[] = [],
        isInvoiceDetailsTable: boolean = false,
        enableBlockedType: boolean = false,
        isNftpRoeEnabled: boolean = false,
        type: string,
        isMciChargeEnabled: boolean = false
    ) => ([
        {
            headerClassName: 'data-table header',
            show: true,
            isActionLink: true,
            accessor: 'materialCode',
            fieldHeader: 'Charge Item',
            sortable: true,
        }, {
            headerClassName: 'data-table header',
            id: 'rev-chargeItem',
            show: true,
            accessor: 'materialDescription',
            fieldHeader: 'Description',
            sortable: true
        }, {
            headerClassName: 'data-table header',
            show: true,
            accessor: 'viewType',
            fieldHeader: 'View Added',
            sortable: true,
        },
        {
            headerClassName: 'data-table header',
            accessor: 'quantity',
            fieldHeader: 'Quantity',
            show: true,
            sortable: true,
            dataType: 'number'
        },
        {
            headerClassName: 'data-table header',
            show: true,
            accessor: 'uom',
            fieldHeader: 'Unit of Measure',
            sortable: true
        }, {
            headerClassName: 'data-table header',
            show: true,
            accessor: 'rate',
            fieldHeader: 'Unit Price',
            sortable: true,
            dataType: 'number'
        }, {
            headerClassName: 'data-table header',
            show: true,
            accessor: 'condCurrency',
            fieldHeader: 'Currency',
            sortable: true
        },
        {
            headerClassName: 'data-table header no-sorting',
            accessor: 'total',
            fieldHeader: 'Amount',
            show: true,
            sortable: false,
            dataType: 'number'
        },
        {
            headerClassName: 'data-table header',
            show: enableBlockedType,
            accessor: 'blockedType',
            fieldHeader: 'Block Type',
            sortable: false
        },
        {
            headerClassName: 'data-table header',
            show: true,
            accessor: 'specialPricingCondition',
            fieldHeader: 'Scaled Pricing',
            sortable: false
        },
        {
            headerClassName: 'data-table header',
            show: false,
            accessor: 'passThrough',
            fieldHeader: 'Pass Through',
            sortable: false
        },
        {
            headerClassName: 'data-table header',
            className: '-number',
            accessor: 'invoiceAmount',
            fieldHeader: type === CostColumnsData.TYPES.REVENUE ? 'Invoice Amount' : 'Supplier Invoice Amount',
            show: isNftpRoeEnabled,
            footer: null,
            sortable: true,
            dataType: 'number'
        },
        {
            headerClassName: 'data-table header',
            accessor: 'invoiceCurrency',
            fieldHeader: type === CostColumnsData.TYPES.REVENUE ? 'Invoice Currency' : 'Supplier Invoice Currency',
            show: isNftpRoeEnabled,
        },
        {
            headerClassName: 'data-table header',
            className: '-number',
            accessor: 'invoiceTaxAmount',
            fieldHeader: type === CostColumnsData.TYPES.REVENUE ? 'Invoice Tax Amount' : 'Supplier Invoice Tax Amount',
            show: isNftpRoeEnabled,
            footer: null,
            sortable: true,
            dataType: 'number'
        },
        {
            headerClassName: 'data-table header',
            accessor: 'invoiceNumber',
            fieldHeader: type === CostColumnsData.TYPES.REVENUE ? 'Invoice Number' : 'Supplier Invoice Number',
            show: isNftpRoeEnabled,
        },
        {
            headerClassName: 'data-table header',
            accessor: 'financialReferenceNumber',
            fieldHeader: 'FRN',
            show: isMciChargeEnabled,
            sortable: true
        },
        {
            headerClassName: 'data-table header',
            accessor: 'externalBookingNumber',
            fieldHeader: 'External Booking',
            show: isMciChargeEnabled,
            sortable: true
        },
        {
            headerClassName: 'data-table header',
            accessor: 'externalItemNumber',
            fieldHeader: 'External Item Number',
            show: isMciChargeEnabled,
            sortable: true
        }
    ])

    public static getCostColumn = (
        currencyList: string[] = CostColumnsData.DEFAULT_CURRENCY_LIST,
        chargeCodes: string[] = [],
        isSummaryTable: boolean = false,
        isExportJobdetails?: boolean,
        showAthenaRows?: boolean,
        isReceivingFCR?: boolean,
        isPODetails?: boolean,
        enableBlockedType: boolean = false,
        isNftpBillable: boolean = false,
        isNftpRoeEnabled: boolean = false,
        isMciChargeEnabled: boolean = false,
        is4PLChargeLevelEnabled: boolean = false,
        showReceivingTriggerDocument: boolean = false
    ) => {
        const data = [{
            headerClassName: 'data-table header',
            id: 'cost-chargeItem',
            show: true,
            accessor: 'chargeItem',
            fieldHeader: 'Charge Item',
            isActionLink: isSummaryTable,
            editOptions: [...chargeCodes]
        }, {
            headerClassName: 'data-table header',
            id: 'cost-chargeItem',
            show: true,
            accessor: 'materialDescription',
            fieldHeader: 'Item Description'
        }, {
            headerClassName: 'data-table header',
            show: isExportJobdetails,
            accessor: 'viewAdded',
            fieldHeader: 'View Added'
        }, {
            headerClassName: 'data-table header',
            id: 'cost-itemC',
            show: true,
            accessor: 'itemType',
            fieldHeader: 'Source Data'
        }, {
            headerClassName: 'data-table header',
            show: showReceivingTriggerDocument,
            accessor: 'triggerDocumentNumber',
            fieldHeader: 'Trigger Document',
            sortable: true
        }, {
            headerClassName: 'data-table header',
            show: isNftpBillable ? false :isReceivingFCR ,
            accessor: 'salesOrderNumber',
            fieldHeader: 'Sales Order number',
            sortable: true
        }, {
            headerClassName: 'data-table header',
            show: !isNftpBillable,
            accessor: 'itemNumber',
            fieldHeader: 'Sales Order item number',
            sortable: true
        }, {
            headerClassName: 'data-table header',
            show: isPODetails,
            isActionLink: true,
            accessor: 'reconsiliationPODetails',
            fieldHeader: 'PO Document Number',
            sortable: false
        },
        {
            headerClassName: 'data-table header',
            show: true,
            accessor: 'status',
            fieldHeader: 'Status',
            sortable: true
        },
        {
            headerClassName: 'data-table header',
            show: enableBlockedType,
            accessor: 'blockedType',
            fieldHeader: 'Block Type',
            sortable: false
        },
        {
            headerClassName: 'data-table header',
            show: isExportJobdetails,
            accessor: 'vendorReference',
            fieldHeader: 'Vendor References',
            sortable: false
        },
        {
            headerClassName: 'data-table header',
            accessor: 'payToParty',
            fieldHeader: 'Pay to Party',
            show: true,
            footer: null,
            sortable: true
        },
        {
            headerClassName: 'data-table header',
            accessor: 'payToPartyName',
            fieldHeader: 'Pay to Party Name',
            show: true,
            footer: null,
            sortable: true
        },
        {
            headerClassName: 'data-table header',
            accessor: 'icbIndicator',
            fieldHeader: 'ICB',
            show: true,
            footer: null,
            sortable: false
        },
        {
            headerClassName: 'data-table header',
            className: '-number',
            accessor: 'quantity',
            fieldHeader: 'QTY',
            show: true,
            footer: null,
            sortable: true,
            dataType: 'number'
        },
        {
            headerClassName: 'data-table header',
            show: true,
            accessor: 'uom',
            fieldHeader: 'UOM',
            footer: null,
            sortable: true
        }, {
            headerClassName: 'data-table header',
            className: '-number',
            show: true,
            accessor: 'rate',
            fieldHeader: `Unit Price`,
            footer: null,
            sortable: true,
            dataType: 'number'
        }, {
            headerClassName: 'data-table header',
            show: true,
            accessor: 'condCurrency',
            fieldHeader: 'Currency',
            footer: null,
            sortable: true
        },
        {
            headerClassName: 'data-table header',
            className: '-number',
            accessor: 'total',
            fieldHeader: 'Amount',
            show: true,
            footer: null,
            sortable: true,
            dataType: 'number'
        },
        {
            headerClassName: 'data-table header',
            accessor: 'exchangeRate',
            fieldHeader: 'ROE',
            show: !isNftpRoeEnabled,
            footer: null,
            sortable: true,
            dataType: 'number'
        },
        {
            headerClassName: 'data-table header',
            accessor: 'localCurrency',
            show: !isNftpRoeEnabled,
            fieldHeader: 'Local Currency',
            editOptions: [...currencyList]

        },
        {
            headerClassName: 'data-table header',
            className: '-number totalLocalCurrency',
            accessor: 'totalLocalCurrency',
            fieldHeader: 'Local Amount',
            show: !isNftpRoeEnabled,
            footer: { label: 'total', type: 'sum' },
            sortable: true,
            dataType: 'number'
        },
        {
            headerClassName: 'data-table header',
            show: true,
            accessor: 'specialPricingCondition',
            fieldHeader: 'Scaled Pricing',
            footer: null,
            sortable: true
        },
        {
            headerClassName: 'data-table header',
            accessor: 'profitCenterRevenue',
            fieldHeader: 'Profit Center',
            show: !isNftpBillable,
            sortable: true
        },
        {
            headerClassName: 'data-table header',
            accessor: 'plant',
            fieldHeader: 'Plant',
            show: true,
            footer: null,
            sortable: true
        },
        {
            headerClassName: 'data-table header',
            accessor: 'purOrgCost',
            fieldHeader: 'Purchase Organisation',
            show: !isNftpBillable,
            sortable: true
        },
        {
            headerClassName: 'data-table header',
            accessor: 'carrierServiceContractCost',
            fieldHeader: 'SVC Number',
            show: !isNftpBillable,
            sortable: true
        },
        {
            headerClassName: 'data-table header',
            accessor: 'contractNumberRevenue',
            fieldHeader: 'Contract Number/Item',
            show: !isNftpBillable,
            sortable: true
        },
        {
            headerClassName: 'data-table header',
            accessor: 'infoRecordCost',
            fieldHeader: 'Info Record',
            show: !isNftpBillable,
            sortable: true
        },
        {
            headerClassName: 'data-table header',
            className: 'errorReason',
            accessor: 'errorReason',
            fieldHeader: 'Error Reason',
            show: true,
            sortable: true
        },
        {
            headerClassName: 'data-table header',
            accessor: 'pricingDate',
            fieldHeader: 'Pricing Date',
            show: !isNftpBillable,
            sortable: true,
            dataType: 'date'
        },
        {
            headerClassName: 'data-table header',
            accessor: 'passThrough',
            fieldHeader: 'Pass Through',
            show: true,
            sortable: true
        },
        {
            headerClassName: 'data-table header',
            accessor: 'serviceRenderedAt',
            fieldHeader: 'Service Rendered At',
            show: showAthenaRows,
            sortable: true
        },
        {
            headerClassName: 'data-table header',
            accessor: 'vatPartner',
            fieldHeader: 'VAT Partner',
            show: true,
            footer: null,
            sortable: true,
            dataType: 'number'
        },
        {
            headerClassName: 'data-table header',
            accessor: 'vatPartnerReasonCodeNo',
            fieldHeader: 'Reason',
            show: false,
            footer: null,
            sortable: true,
        },
        {
            headerClassName: 'data-table header',
            className: '-number',
            accessor: 'tax',
            fieldHeader: 'TAX',
            show: !isNftpBillable,
            footer: null,
            sortable: true,
            dataType: 'number'
        },
        {
            headerClassName: 'data-table header',
            accessor: 'insertBy',
            fieldHeader: 'Created By',
            show: true,
            sortable: true
        },
        {
            headerClassName: 'data-table header',
            accessor: 'insertDate',
            fieldHeader: 'Created Date',
            show: true,
            sortable: true,
            dataType: 'date'
        },
        {
            headerClassName: 'data-table header',
            accessor: 'updatedBy',
            fieldHeader: 'Last Updated By',
            show: true,
            sortable: true
        },
        {
            headerClassName: 'data-table header',
            accessor: 'updateDate',
            fieldHeader: 'Last Updated Date',
            show: true,
            sortable: true,
            dataType: 'date'
        }, {
            headerClassName: 'data-table header',
            accessor: 'dynamicFields',
            fieldHeader: 'Dyanamic Fields',
            show: showAthenaRows,
            sortable: true,
        },
        {
            headerClassName: 'data-table header',
            accessor: 'essoRateDetailId',
            fieldHeader: 'Rate Detail Id',
            show: true,
            sortable: true,
            dataType: 'number'
        },
        {
            headerClassName: 'data-table header',
            accessor: 'athenaRateIdentifier',
            fieldHeader: 'Rate Identifier',
            show: showAthenaRows,
            sortable: true,
        },
        {
            headerClassName: 'data-table header',
            accessor: 'chargeValidityBased',
            fieldHeader: 'Rates Based On',
            show: showAthenaRows,
            sortable: true,
        },
        {
            headerClassName: 'data-table header',
            accessor: 'contractStartDate',
            fieldHeader: 'Valid From',
            show: showAthenaRows,
            sortable: true,
            dataType: 'date'
        },
        {
            headerClassName: 'data-table header',
            accessor: 'contractEndDate',
            fieldHeader: 'Valid To',
            show: showAthenaRows,
            sortable: true,
            dataType: 'date'
        },
        {
            headerClassName: 'data-table header',
            className: '-number',
            accessor: 'invoiceAmount',
            fieldHeader: 'Supplier Invoice Amount',
            show: isNftpRoeEnabled,
            footer: null,
            sortable: true,
            dataType: 'number'
        },
        {
            headerClassName: 'data-table header',
            accessor: 'invoiceCurrency',
            fieldHeader: 'Supplier Invoice Currency',
            show: isNftpRoeEnabled,
        },
        {
            headerClassName: 'data-table header',
            className: '-number',
            accessor: 'invoiceTaxAmount',
            fieldHeader: 'Supplier Invoice Tax Amount',
            show: isNftpRoeEnabled,
            footer: null,
            sortable: true,
            dataType: 'number'
        },
        {
            headerClassName: 'data-table header',
            accessor: 'invoiceNumber',
            fieldHeader: 'Supplier Invoice Number',
            show: isNftpRoeEnabled,
        },
        {
            headerClassName: 'data-table header',
            accessor: 'financialReferenceNumber',
            fieldHeader: 'FRN',
            show: isMciChargeEnabled,
            sortable: true
        },
        {
            headerClassName: 'data-table header',
            accessor: 'externalBookingNumber',
            fieldHeader: 'External Booking',
            show: isMciChargeEnabled,
            sortable: true
        },
        {
            headerClassName: 'data-table header',
            accessor: 'externalItemNumber',
            fieldHeader: 'External Item Number',
            show: isMciChargeEnabled,
            sortable: true
        },
        {
            headerClassName: 'data-table header',
            accessor: 'chargeLevel',
            fieldHeader: 'Charge Level',
            show: is4PLChargeLevelEnabled,
            sortable: true
        },
        {
            headerClassName: 'data-table header',
            accessor: 'clrNumber',
            fieldHeader: 'CLR Number',
            show: is4PLChargeLevelEnabled,
            sortable: true
        },
        {
            headerClassName: 'data-table header',
            accessor: 'equipmentNumber',
            fieldHeader: 'Equipment Number',
            show: is4PLChargeLevelEnabled,
            sortable: true
        },
        {
            headerClassName: 'data-table header',
            accessor: 'billOfLadingNumber',
            fieldHeader: 'Bill of Lading Number',
            show: is4PLChargeLevelEnabled,
            sortable: true
        }];
        return [...data]
    };

    public static getRevenueColumn = (
        currencyList: string[] = CostColumnsData.DEFAULT_CURRENCY_LIST,
        chargeCodes: string[] = [],
        isSummaryTable: boolean = false,
        isInvoiceDetailsTable: boolean = false,
        isExportJobdetails?: boolean,
        showAthenaRows?: boolean,
        isReceivingFCR?: boolean,
        showServiceProvider?: boolean,
        enableBlockedType: boolean = false,
        isNftpBillable: boolean = false,
        isNftpRoeEnabled: boolean = false,
        isMciChargeEnabled: boolean = false,
        is4PLChargeLevelEnabled: boolean = false,
        isNonStandardFcrEnabled: boolean = false
    ) => {
        const data1 = [{
            headerClassName: 'data-table header',
            show: true,
            isActionLink: isSummaryTable,
            accessor: 'chargeItem',
            fieldHeader: 'Charge Item'
        }, {
            headerClassName: 'data-table header',
            id: 'rev-chargeItem',
            show: true,
            accessor: 'materialDescription',
            fieldHeader: 'Item Description'
        }, {
            headerClassName: 'data-table header',
            show: isExportJobdetails,
            accessor: 'viewAdded',
            fieldHeader: 'View Added'
        }, {
            headerClassName: 'data-table header',
            show: true,
            accessor: 'itemType',
            fieldHeader: 'Source Data'
        }, {
            headerClassName: 'data-table header',
            show: isNftpBillable ? false : isReceivingFCR,
            accessor: 'salesOrderNumber',
            fieldHeader: 'Sales Order number',
            sortable: true
        }, {
            headerClassName: 'data-table header',
            show: !isNftpBillable,
            accessor: 'itemNumber',
            fieldHeader: 'Sales Order item',
            sortable: true
        },
        {
            headerClassName: 'data-table header',
            show: true,
            accessor: 'status',
            fieldHeader: 'Status',
            sortable: true
        },
        {
            headerClassName: 'data-table header',
            show: enableBlockedType,
            accessor: 'blockedType',
            fieldHeader: 'Block Type',
            sortable: false
        },
        {
            headerClassName: 'data-table header',
            accessor: 'billToParty',
            fieldHeader: 'Bill to Party',
            show: true,
            footer: null,
            sortable: true
        },
        {
            headerClassName: 'data-table header',
            accessor: 'billToPartyName',
            fieldHeader: 'Bill to Party Name',
            show: true,
            footer: null,
            sortable: true
        },
        {
            headerClassName: 'data-table header',
            accessor: 'ServiceProvider',
            fieldHeader: 'Service Provider',
            show: showServiceProvider,
            footer: null,
            sortable: false
        },
        {
            headerClassName: 'data-table header',
            accessor: 'icbIndicator',
            fieldHeader: 'ICB',
            show: true,
            footer: null,
            sortable: false
        },
        {
            headerClassName: 'data-table header',
            className: '-number',
            accessor: 'quantity',
            fieldHeader: 'QTY',
            show: true,
            footer: null,
            sortable: true,
            dataType: 'number'
        },
        {
            headerClassName: 'data-table header',
            show: true,
            accessor: 'uom',
            fieldHeader: 'UOM',
            footer: null,
            sortable: true
        }, {
            headerClassName: 'data-table header',
            className: '-number',
            show: true,
            accessor: 'rate',
            fieldHeader: 'Unit price',
            footer: null,
            sortable: true,
            dataType: 'number'
        }, {
            headerClassName: 'data-table header',
            show: true,
            accessor: 'condCurrency',
            fieldHeader: 'Currency',
            footer: null,
            sortable: true
        },
        {
            headerClassName: 'data-table header',
            className: '-number',
            accessor: 'total',
            fieldHeader: 'Amount',
            show: true,
            footer: null,
            sortable: true,
            dataType: 'number'
        }, {
            headerClassName: 'data-table header',
            accessor: 'exchangeRate',
            fieldHeader: 'ROE',
            show: !isNftpRoeEnabled,
            footer: null,
            sortable: true,
            dataType: 'number'
        },
        {
            headerClassName: 'data-table header',
            accessor: 'localCurrency',
            show: !isNftpRoeEnabled,
            fieldHeader: 'Local Currency',
            editOptions: [...currencyList]
        },
        {
            headerClassName: 'data-table header',
            className: '-number totalLocalCurrency',
            accessor: 'totalLocalCurrency',
            fieldHeader: 'Local Amount',
            show: !isNftpRoeEnabled,
            footer: { label: 'total', type: 'sum' },
            sortable: true,
            dataType: 'number'
        },
        {
            headerClassName: 'data-table header',
            show: true,
            accessor: 'specialPricingCondition',
            fieldHeader: 'Scaled Pricing',
            footer: null,
            sortable: true
        },];
        const data2 = [{
            headerClassName: 'data-table header',
            accessor: 'invoiceExchangeRate',
            fieldHeader: 'Invoice Exchange Rate',
            show: true,
            footer: null,
            sortable: true,
            dataType: 'number'
        },
        {
            headerClassName: 'data-table header',
            accessor: 'invoiceCurrency',
            show: true,
            fieldHeader: 'Invoice Currency',
            editOptions: [...currencyList]
        },
        {
            headerClassName: 'data-table header',
            className: '-number totalInvoiceAmount',
            accessor: 'totalInvoiceAmount',
            fieldHeader: 'Invoice Amount',
            show: true,
            footer: { label: 'total', type: 'sum' },
            sortable: true,
            dataType: 'number'
        }];
        const data3 = [
            {
                headerClassName: 'data-table header',
                accessor: 'payTermsRevenue',
                fieldHeader: 'Payment Terms',
                show: !isNftpBillable,
                sortable: true
            },
            {
                headerClassName: 'data-table header',
                accessor: 'profitCenterRevenue',
                fieldHeader: 'Profit Center',
                show: !isNftpBillable,
                sortable: true
            },
            {
                headerClassName: 'data-table header',
                className: 'errorReason',
                accessor: 'errorReason',
                fieldHeader: 'Error Reason',
                show: true,
                sortable: true
            },
            {
                headerClassName: 'data-table header',
                accessor: 'pricingDate',
                fieldHeader: 'Pricing Date',
                show: !isNftpBillable,
                sortable: true,
                dataType: 'date'
            },
            {
                headerClassName: 'data-table header',
                accessor: 'billingDate',
                fieldHeader: 'Billing Date',
                show: true,
                sortable: true,
                dataType: 'date'
            },
            {
                headerClassName: 'data-table header',
                accessor: 'passThrough',
                fieldHeader: 'Pass Through',
                show: true,
                sortable: true
            },
            {
                headerClassName: 'data-table header',
                accessor: 'serviceRenderedAt',
                fieldHeader: 'Service Rendered At',
                show: showAthenaRows,
                sortable: true
            },
            {
                headerClassName: 'data-table header',
                accessor: 'vatPartner',
                fieldHeader: 'VAT Partner',
                show: true,
                footer: null,
                sortable: true
            },
            {
                headerClassName: 'data-table header',
                accessor: 'vatPartnerReasonCodeNo',
                fieldHeader: 'Reason',
                show: false,
                footer: null,
                sortable: true,
            },
            {
                headerClassName: 'data-table header',
                className: '-number',
                accessor: 'tax',
                fieldHeader: 'TAX',
                show: !isNftpBillable,
                footer: null,
                sortable: true,
                dataType: 'number'
            },
            {
                headerClassName: 'data-table header',
                className: '-number',
                accessor: 'taxRatio',
                fieldHeader: 'Tax Ratio (%)',
                show: !isNftpBillable,
                sortable: true,
                dataType: 'number'
            },
            {
                headerClassName: 'data-table header',
                accessor: 'insertBy',
                fieldHeader: 'Created By',
                show: true,
                sortable: true
            },
            {
                headerClassName: 'data-table header',
                accessor: 'insertDate',
                fieldHeader: 'Created Date',
                show: true,
                sortable: true,
                dataType: 'date'
            },
            {
                headerClassName: 'data-table header',
                accessor: 'updatedBy',
                fieldHeader: 'Last Updated By',
                show: true,
                sortable: true
            },
            {
                headerClassName: 'data-table header',
                accessor: 'updateDate',
                fieldHeader: 'Last Updated Date',
                show: true,
                sortable: true,
                dataType: 'date'
            },
            {
                headerClassName: 'data-table header',
                accessor: 'dynamicFields',
                fieldHeader: 'Dyanamic Fields',
                show: showAthenaRows,
                sortable: true,
            },
            {
                headerClassName: 'data-table header',
                accessor: 'essoRateDetailId',
                fieldHeader: 'Rate Detail Id',
                show: true,
                sortable: true,
                dataType: 'number'
            },
            {
                headerClassName: 'data-table header',
                accessor: 'athenaRateIdentifier',
                fieldHeader: 'Rate Identifier',
                show: showAthenaRows,
                sortable: true,
            },
            {
                headerClassName: 'data-table header',
                accessor: 'chargeValidityBased',
                fieldHeader: 'Rates Based On',
                show: showAthenaRows,
                sortable: true,
            },
            {
                headerClassName: 'data-table header',
                accessor: 'contractStartDate',
                fieldHeader: 'Valid From',
                show: showAthenaRows,
                sortable: true,
            },
            {
                headerClassName: 'data-table header',
                accessor: 'contractEndDate',
                fieldHeader: 'Valid To',
                show: showAthenaRows,
                sortable: true,
            },
            {
                headerClassName: 'data-table header',
                className: '-number',
                accessor: 'invoiceAmount',
                fieldHeader: 'Invoice Amount',
                show: isNftpRoeEnabled,
                footer: null,
                sortable: true,
                dataType: 'number'
            },
            {
                headerClassName: 'data-table header',
                accessor: 'invoiceCurrency',
                fieldHeader: 'Invoice Currency',
                show: isNftpRoeEnabled,
            },
            {
                headerClassName: 'data-table header',
                className: '-number',
                accessor: 'invoiceTaxAmount',
                fieldHeader: 'Invoice Tax Amount',
                show: isNftpRoeEnabled,
                footer: null,
                sortable: true,
                dataType: 'number'
            },
            {
                headerClassName: 'data-table header',
                accessor: 'invoiceNumber',
                fieldHeader: 'Invoice Number',
                show: isNftpRoeEnabled,
            },
            {
                headerClassName: 'data-table header',
                accessor: 'financialReferenceNumber',
                fieldHeader: 'FRN',
                show: isMciChargeEnabled,
                sortable: true
            },
            {
                headerClassName: 'data-table header',
                accessor: 'externalBookingNumber',
                fieldHeader: 'External Booking',
                show: isMciChargeEnabled,
                sortable: true
            },
            {
                headerClassName: 'data-table header',
                accessor: 'externalItemNumber',
                fieldHeader: 'External Item Number',
                show: isMciChargeEnabled,
                sortable: true
            },
            {
                headerClassName: 'data-table header',
                accessor: 'chargeLevel',
                fieldHeader: 'Charge Level',
                show: is4PLChargeLevelEnabled,
                sortable: true
            },
            {
                headerClassName: 'data-table header',
                accessor: 'clrNumber',
                fieldHeader: 'CLR Number',
                show: is4PLChargeLevelEnabled,
                sortable: true
            },
            {
                headerClassName: 'data-table header',
                accessor: 'equipmentNumber',
                fieldHeader: 'Equipment Number',
                show: is4PLChargeLevelEnabled,
                sortable: true
            },
            {
                headerClassName: 'data-table header',
                accessor: 'billOfLadingNumber',
                fieldHeader: 'Bill of Lading Number',
                show: is4PLChargeLevelEnabled,
                sortable: true
            },
            {
                headerClassName: 'data-table header',
                accessor: 'internalReferenceNumber',
                fieldHeader: 'IRN',
                show: isNonStandardFcrEnabled,
                sortable: true
            }
        ]
        if (isInvoiceDetailsTable) {
            return [...data1, ...data2, ...data3]
        }
        else {
            return [...data1, ...data3];
        }
    };

    public static getDialogEqCostRevSubCols = (isExtraDocumentFeatureEnabled: boolean) => ([
        {
            headerClassName: 'data-table header',
            accessor: 'EquipmentNumber',
            isHyperlink: false,
            fieldHeader: 'Equipment Number',
            show: true
        }, {
            headerClassName: 'data-table header',
            accessor: 'container',
            isHyperlink: false,
            fieldHeader: 'Container Size/Type',
            show: true
        }, {
            headerClassName: 'data-table header',
            accessor: 'substitution',
            isHyperlink: false,
            fieldHeader: 'Substitution Size/Type',
            show: true
        }, {
            headerClassName: 'data-table header',
            accessor: 'DocumentNumber',
            isHyperlink: false,
            fieldHeader: isExtraDocumentFeatureEnabled ? 'Document Number' : 'FCR Number',
            show: true
        }, {
            headerClassName: 'data-table header',
            accessor: 'cBLNumber',
            isHyperlink: false,
            fieldHeader: 'CBL Number',
            show: true
        }, {
            headerClassName: 'data-table header',
            accessor: 'BookingNumber',
            isHyperlink: false,
            fieldHeader: 'Booking Number',
            show: true,
        }, {
            headerClassName: 'data-table header',
            accessor: 'QuantityPercentage',
            editable: true,
            editType: 'text',
            fieldHeader: '%',
            show: true,
        }, {
            headerClassName: 'data-table header',
            accessor: 'BookingSplitId',
            isHyperlink: false,
            fieldHeader: 'Booking Split ID',
            show: true
        }, {
            headerClassName: 'data-table header',
            accessor: 'essoRateDetailsSplitId',
            isHyperlink: false,
            fieldHeader: 'Rate Details Split ID',
            show: true
        }
    ])

    public static getCBLCostColumn = (currencyList: string[] = CostColumnsData.DEFAULT_CURRENCY_LIST, chargeCodes: string[] = [], isSummaryTable: boolean = false) => {
        const data = [{
            headerClassName: 'data-table header no-sorting',
            id: 'cost-chargeItem',
            show: true,
            accessor: 'chargeItem',
            fieldHeader: 'Charge Item',
            isActionLink: isSummaryTable,
            editOptions: [...chargeCodes],
            sortable: false,
        }, {
            headerClassName: 'data-table header no-sorting',
            id: 'cost-chargeItem',
            show: true,
            accessor: 'materialDescription',
            fieldHeader: 'Item Desc',
            sortable: false,
        }, {
            headerClassName: 'data-table header no-sorting',
            accessor: 'quantity',
            fieldHeader: 'Quantity',
            show: true,
            footer: null,
            sortable: false,
            dataType: 'number'
        },
        {
            headerClassName: 'data-table header no-sorting',
            show: true,
            accessor: 'uom',
            fieldHeader: 'Unit of Meassure',
            footer: null,
            sortable: false
        }, {
            headerClassName: 'data-table header no-sorting',
            show: true,
            accessor: 'rate',
            fieldHeader: `Unit Price`,
            footer: null,
            sortable: false,
            dataType: 'number'
        }, {
            headerClassName: 'data-table header no-sorting',
            show: true,
            accessor: 'condCurrency',
            fieldHeader: 'Currency',
            footer: null,
            sortable: false
        },
        {
            headerClassName: 'data-table header no-sorting',
            show: true,
            accessor: 'status',
            fieldHeader: 'Status',
            sortable: false
        }, {
            headerClassName: 'data-table header fixedNumber no-sorting',
            className: 'deleteButton',
            show: true,
            accessor: 'delete',
            isActionLink: true,
            id: 'exportJobNumber-col-link',
            fieldHeader: '',
            sortable: false
        }]
        return [...data]
    };
    public static getCostColumnDestination = (showAthenaRows: boolean = false, isPODetails: boolean = false, enableBlockedType: boolean = false, isNftpBillable: boolean = false, isNftpRoeEnabled: boolean = false, isMciChargeEnabled: boolean = false) => {
        if (showAthenaRows) {
            const costColumns = [...CostColumnsData.getCostColumn(
                [], [], false, false, false, false, isPODetails, enableBlockedType, isNftpBillable, isNftpRoeEnabled, isMciChargeEnabled
            )];
            return [...costColumns]
        }
        const data = [...CostColumnsData.getCostColumn(
            [], [], false, false, false, false, isPODetails, enableBlockedType, isNftpBillable, isNftpRoeEnabled, isMciChargeEnabled
        )];
        data[data.length - 1].accessor = 'rateDetailId';
        return [...data]
    };

    public static getCBLRevenueColumn = (currencyList: string[] = CostColumnsData.DEFAULT_CURRENCY_LIST, chargeCodes: string[] = [], isSummaryTable: boolean = false, isInvoiceDetailsTable: boolean = false) => {
        const data = [{
            headerClassName: 'data-table header no-sorting',
            show: true,
            isActionLink: isSummaryTable,
            accessor: 'chargeItem',
            fieldHeader: 'Charge Item'
        }, {
            headerClassName: 'data-table header no-sorting',
            id: 'rev-chargeItem',
            show: true,
            accessor: 'materialDescription',
            fieldHeader: 'Item Desc'
        },
        {
            headerClassName: 'data-table header no-sorting',
            show: true,
            accessor: 'rate',
            fieldHeader: 'Unit price',
            footer: null,
            sortable: true,
            dataType: 'number'
        }, {
            headerClassName: 'data-table header no-sorting',
            show: true,
            accessor: 'condCurrency',
            fieldHeader: 'Currency',
            footer: null,
            sortable: true
        },
        {
            headerClassName: 'data-table header no-sorting',
            accessor: 'quantity',
            fieldHeader: 'Quantity',
            show: true,
            footer: null,
            sortable: true,
            dataType: 'number'
        },
        {
            headerClassName: 'data-table header no-sorting',
            show: true,
            accessor: 'uom',
            fieldHeader: 'Unit of Meassure',
            footer: null,
            sortable: true
        }, {
            headerClassName: 'data-table header no-sorting',
            show: true,
            accessor: 'status',
            fieldHeader: 'Status',
            sortable: true
        },
        {
            headerClassName: 'data-table header fixedNumber no-sorting',
            className: 'deleteButton',
            show: true,
            accessor: 'delete',
            isActionLink: true,
            id: 'exportJobNumber-col-link',
            fieldHeader: '',
            sortable: false
        }];
        return [...data];
    };
    public static getRevenueColumnDestination = (
        showAthenaRows?: boolean,
        showServiceProvider?: boolean,
        enableBlockedType?: boolean,
        isNftpBillable?: boolean,
        isNftpRoeEnabled?: boolean,
        isMciChargeEnabled?: boolean
    ) => {
        if (showServiceProvider) {
            return [...CostColumnsData.getRevenueColumn([], [], false, false, false, showAthenaRows, false, showServiceProvider, enableBlockedType, isNftpBillable, isNftpRoeEnabled, isMciChargeEnabled)];
        }

        const data = [...CostColumnsData.getRevenueColumn([], [], false, false, false, showAthenaRows, false, false, enableBlockedType, isNftpBillable, isNftpRoeEnabled, isMciChargeEnabled)];
        // The destination flows read rateDetailId off the row (VAT partner / bill-to-party payloads),
        // so the column has to exist. It used to be produced by renaming whichever column happened to
        // be last, which silently retargeted every time a column was appended to getRevenueColumn.
        return [...data, {
            headerClassName: 'data-table header',
            accessor: 'rateDetailId',
            fieldHeader: '',
            show: false,
            sortable: false
        }];
    };
    public static getRevenueColumnIssueInvoicePage = (isBulk: boolean, isDestination: boolean = false, isExtraDocumentFeatureEnabled: boolean) => {
        let data = [...CostColumnsData.getRevenueColumn([], [], false)];
        if (isBulk) {
            data = data.filter(x => {
                return ['chargeItem', 'materialDescription', 'itemNumber', 'quantity', 'uom', 'rate', 'condCurrency', 'total', 'exchangeRate', 'localCurrency', 'totalLocalCurrency', 'vatPartner', 'tax', 'taxRatio', 'specialPricingCondition'].indexOf(x.accessor) !== -1;
            });
            data.forEach((x: any) => {
                if (['quantity', 'rate', 'total', 'exchangeRate', 'totalLocalCurrency', 'tax', 'taxRatio', 'specialPricingCondition'].indexOf(x.accessor) !== -1) {
                    if (x.className) {
                        x.className = x.className.replace('-number', '');
                    }
                }
            })
            return data;
        }
        else {
            const columnToAdd = {
                headerClassName: 'data-table header',
                accessor: 'number',
                fieldHeader: isExtraDocumentFeatureEnabled ? 'Document Number' : 'FCR Number',
                show: true,
                sortable: true,
            };
            if (isDestination) {
                columnToAdd.fieldHeader = 'ETS Number'
            }
            data = data.filter(x => {
                return ['chargeItem', 'materialDescription', 'itemNumber', 'quantity', 'uom', 'rate', 'condCurrency', 'total', 'exchangeRate', 'localCurrency', 'totalLocalCurrency', 'vatPartner', 'tax', 'taxRatio', 'specialPricingCondition'].indexOf(x.accessor) !== -1;
            });
            data.forEach((x: any) => {
                if (x.accessor === 'chargeItem') {
                    x.isActionLink = true;
                }
                if (['quantity', 'rate', 'total', 'exchangeRate', 'totalLocalCurrency', 'tax', 'taxRatio', 'specialPricingCondition'].indexOf(x.accessor) !== -1) {
                    if (x.className) {
                        x.className = x.className.replace('-number', '');
                    }
                }
            })
            return [columnToAdd, ...data];
        }
    };
}
export default CostColumnsData